import type { ID } from "@services/sdk/types";

import type { IProductConstructorParams } from "@services/sdk/interfaces";
import Product from "@services/sdk/models/product";

interface IATUScheduleItemConstructorParams {
	id: ID;
	product: IProductConstructorParams;
}

interface IATUScheduleConstructorParams {
	isPaused: boolean;
	isEnabled: boolean;
	paymentRetries: number;
	items: Array<IATUScheduleItemConstructorParams>;
}

class ATUSchedule {
	public static EmptyConstructorParams: IATUScheduleConstructorParams = {
		isPaused: false,
		isEnabled: false,
		paymentRetries: 0,
		items: [],
	};

	public static ConstructEmpty(): ATUSchedule {
		return ATUSchedule.Construct(ATUSchedule.EmptyConstructorParams);
	}

	public static Construct(params: IATUScheduleConstructorParams): ATUSchedule {
		return new ATUSchedule(params);
	}

	responseData: IATUScheduleConstructorParams;

	constructor(params: IATUScheduleConstructorParams) {
		this.responseData = params;
	}

	get items(): Array<{ id: ID; product: Product }> {
		return this.responseData.items.map((item) => ({
			id: item.id,
			product: Product.Construct(item.product),
		}));
	}

	get isPaused(): boolean {
		return this.responseData.isPaused;
	}

	get isEnabled(): boolean {
		return this.responseData.isEnabled;
	}

	get paymentRetries(): number {
		return this.responseData.paymentRetries;
	}

	getScheduleIdForProductId(productId: ID): ID | null {
		const result = this.items.find((item) => item.product.id === productId);

		if (!result) {
			return null;
		}

		return result.id;
	}
}

export default ATUSchedule;
